import React from "react";
import { Link } from "react-router-dom";

export default function Cancel() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-50 px-4 pt-24">
      <h1 className="text-3xl font-bold text-red-700 mb-2">
        ❌ Payment Cancelled
      </h1>

      <p className="text-gray-700 mb-6 max-w-md text-center">
        Your payment was cancelled. No charges were made.
        You can try again anytime.
      </p>

      <div className="flex flex-col gap-3 w-full max-w-xs">
        <Link
          to="/cart"
          className="bg-black text-white px-6 py-3 rounded-lg text-center hover:bg-gray-900 transition"
        >
          Return to Cart
        </Link>

        <Link
          to="/"
          className="bg-red-600 text-white px-6 py-3 rounded-lg text-center hover:bg-red-700 transition"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
